export default __webpack_public_path__ + "static/media/retailors-inactive.35519cc0.svg";